// extracted by mini-css-extract-plugin
export var errorIcon = "_ly-1";
export var nameLogo = "_ly-0";